import { Handle, Position } from '@xyflow/react';

function TipologiaNode({ data, selected }) {
  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 shadow-md min-w-[180px] transition-all ${
        selected
          ? 'border-purple-600 bg-purple-100 ring-2 ring-purple-300'
          : 'border-purple-400 bg-purple-50 hover:border-purple-500 hover:shadow-lg'
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-purple-500" />

      <div className="flex items-center gap-2 mb-1">
        <span className="text-lg">🔧</span>
        <span className="text-xs font-semibold text-purple-600 uppercase tracking-wide">Tipologia</span>
      </div>

      <div className="font-semibold text-gray-800 text-sm leading-tight">
        {data.nome}
      </div>

      {data.descrizione && (
        <div className="text-xs text-gray-500 mt-1 line-clamp-2">
          {data.descrizione}
        </div>
      )}

      <Handle type="source" position={Position.Right} className="!bg-purple-500" />
    </div>
  );
}

export default TipologiaNode;
